import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import { AccessPage } from "../../screens/settings/index.ts";

/** `/settings/access`: what each role can see of the company's data (see `AccessPage`). */
export const Route = createFileRoute("/_app/settings/access")({
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("access.get", {})),
  component: AccessPage,
});
